import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { LogService } from 'common-components';
import { environment } from '../../../environments/environment';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    constructor(private logService: LogService, private injector: Injector) { }

    public handleError(error: Error | HttpErrorResponse): void {

        let message;
        let stackTrace;

        if (error instanceof HttpErrorResponse) {
            // server error
            message = this.getServerMessage(error);
            stackTrace = this.getServerStack(error);
        } else {
            // client error
            message = this.getClientMessage(error);
            stackTrace = this.getClientStack(error);
        }

        const router = this.injector.get(Router);
        // write the error to log service
        this.logService.error(message, router ? router.url : 'no url', stackTrace, this.userAgent);

        let destination = '500';
        if (error instanceof HttpErrorResponse && error.status === 503) {
            destination = '503';
        }

        router.navigate([destination]).then(() => {
            // when not in production => log it to the console anyway
            if (!environment.production) {
                // eslint-disable-next-line
                console.error(error);
            }
        });
    }

    private get userAgent(): string {
        if (!window || !window.navigator) {
            return 'no navigator';
        }
        return window.navigator.userAgent;
    }

    private getClientMessage(error: Error): string {
        if (!navigator.onLine) {
            return 'Geen internetverbinding.';
        }

        return error.message || error.toString();
    }

    private getClientStack(error: Error): string {
        return error.stack;
    }

    private getServerMessage(error: HttpErrorResponse): string {
        return error.statusText;
    }

    private getServerStack(error: HttpErrorResponse): string {
        return JSON.stringify(error);
    }
}
